/* eslint-disable */
import React, { Component } from 'react';
import style from './LoadingSpinner';

export default class LoadingSpinner extends Component {
    getBallStyle() {
        return {
            backgroundColor: this.props.backgroundColor
                ? ` ${this.props.backgroundColor}`
                : 'gray',
            width: '16px',
            height: '16px',
            margin: '8px',
            borderRadius: '100%',
            verticalAlign: this.props.verticalAlign,
        };
    }

    getAnimationStyle(i) {
        const animation = [
            'spinner-anim',
            '0.75s',
            `${i * 0.12}s`,
            'infinite',
            'cubic-bezier(.2,.68,.18,1.08)',
        ].join(' ');
        const animationFillMode = 'both';

        return {
            animation,
            animationFillMode,
        };
    }

    getStyle(i) {
        return {
            ...this.getBallStyle(i),
            ...this.getAnimationStyle(i),
            display: 'inline-block',
        };
    }

    render() {
        return (
            <div
                className={`spinner-container${
                    this.props.className ? ` ${this.props.className}` : ''
                }`}
            >
                <div style={this.getStyle(1)} />
                <div style={this.getStyle(2)} />
                <div style={this.getStyle(3)} />
            </div>
        );
    }
}
